import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { trackPageView } from "./api/analyticsAPI";

import Main from "./pages/user/main";
import BlogsPage from "./components/user/blog/listBlog";
import BlogsDetail from "./components/user/blog/detailBlog";
import LoginForm from "./components/admin/login";
import ProtectedRoute from "./components/ProtectedRoute";
import Auth0Callback from "./components/Auth0Callback";

import Dashboard from "./pages/admin/dashboard";
import Blog from "./pages/admin/blogs";
import Client from "./pages/admin/clients";
import Project from "./pages/admin/projects";
import Service from "./pages/admin/services";
import UsersPage from "./pages/admin/users";
import N404 from "./components/404";

// ── Auto-track every route change ───────────────────────────
function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    // Only track public-facing pages, not admin
    if (!location.pathname.startsWith("/admin")) {
      trackPageView(location.pathname + location.search);
    }
  }, [location]);
  return null;
}

const App = () => {
  return (
    <>
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/blog" element={<BlogsPage />} />
        <Route path="/blog/:id" element={<BlogsDetail />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/callback" element={<Auth0Callback />} />

        {/* Admin Pages */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/blog"
          element={
            <ProtectedRoute>
              <Blog />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/client"
          element={
            <ProtectedRoute>
              <Client />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/project"
          element={
            <ProtectedRoute>
              <Project />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/service"
          element={
            <ProtectedRoute>
              <Service />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute>
              <UsersPage />
            </ProtectedRoute>
          }
        />

        {/* 404 */}
        <Route path="*" element={<N404 />} />
      </Routes>
    </>
  );
};

export default App;
